import { cn } from '@/core/utils/cn';

interface FormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  columns?: 1 | 2 | 3;
  className?: string;
}

export function FormSection({ title, description, children, columns = 1, className }: FormSectionProps) {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  };

  return (
    <div className={cn('space-y-4', className)}>
      <div>
        <h3 className="text-[14px] font-semibold text-hms-text">{title}</h3>
        {description && <p className="text-[12px] text-hms-textDim mt-0.5">{description}</p>}
      </div>
      <div className={cn('grid gap-4', gridCols[columns])}>
        {children}
      </div>
    </div>
  );
}
